import styled from "styled-components";
import { palette } from "styled-theme";
import { transition, borderRadius } from "../../settings/style-util";
import WithDirection from "../../settings/withDirection";

const SidebarWrapper = styled.div`
  .sidebar-menu-icons {
    margin-left: ${(props) => (props["data-rtl"] === "rtl" ? "5px" : "0")};
  }

  /* Mobile overlay backdrop — appears when sidebar is open on mobile */
  .sidebar-mobile-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 999;
    animation: sidebarFadeIn 0.18s ease-out;
  }

  @keyframes sidebarFadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  /* Mobile + tablet: float the sidebar above content instead of pushing it */
  @media only screen and (max-width: 991px) {
    .isomorphicSidebar.is-mobile {
      position: fixed !important;
      top: 0;
      left: 0;
      bottom: 0;
      height: 100vh;
      z-index: 1001;
      box-shadow: 4px 0 20px rgba(0, 0, 0, 0.25);
      transition: transform 0.25s ease, visibility 0s linear 0s;
    }

    .isomorphicSidebar.is-mobile.ant-layout-sider-collapsed {
      transform: translateX(-100%);
      box-shadow: none;
      visibility: hidden;
      pointer-events: none;
      transition: transform 0.25s ease, visibility 0s linear 0.25s;
    }
  }
  .isomorphicSidebar.ant-layout-sider
    .isoDashboardMenu
    .ant-menu-item-selected {
    border-left: ${(props) =>
      props["data-rtl"] === "rtl"
        ? "5px solid transparent;"
        : "5px solid var(--accent-color, #002a49);"};
    border-right: ${(props) =>
      props["data-rtl"] === "rtl"
        ? "5px solid var(--accent-color, #002a49);"
        : "0px solid transparent;"};
    background-color: #141414 !important;
  }
  .sidebar-logo-area {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    padding: 10px 16px;
    background: ##1c1917;
    flex-shrink: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    position: relative;
  }

  .sidebar-close-btn {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    width: 34px;
    height: 34px;
    border-radius: 8px;
    border: 0;
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    transition: background 0.15s;
  }

  .sidebar-close-btn:hover,
  .sidebar-close-btn:focus {
    background: rgba(255, 255, 255, 0.18);
    outline: none;
  }

  .sidebar-logo-full {
    max-height: 38px;
    width: auto;
    max-width: 160px;
    // filter: brightness(0) invert(1);
    background-color: #fff;
  }

  .sidebar-logo-collapsed {
    max-height: 32px;
    max-width: 40px;
    width: auto;
    filter: brightness(0) invert(1);
    object-fit: contain;
  }

  .isomorphicSidebar {
    z-index: 1000;
    background: ${palette("secondary", 0)};
    width: 220px;
    flex: 0 0 220px;

    @media only screen and (max-width: 991px) {
      width: 250px !important;
      flex: 0 0 250px !important;
    }

    &.ant-layout-sider-collapsed {
      @media only screen and (max-width: 991px) {
        /* keep width — overlay slides off-screen via transform */
        width: 250px !important;
        min-width: 250px !important;
        max-width: 250px !important;
        flex: 0 0 250px !important;
      }
    }

    .isoLogoWrapper {
      display: none;
      height: 70px;
      background: rgba(0, 0, 0, 0.3);
      margin: 0;
      padding: 0 10px;
      text-align: center;
      overflow: hidden;
      ${borderRadius()};

      h3 {
        a {
          font-size: 21px;
          font-weight: 300;
          line-height: 70px;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: ${palette("grayscale", 6)};
          display: block;
          text-decoration: none;
        }
      }
    }

    &.ant-layout-sider-collapsed {
      .isoLogoWrapper {
        padding: 0;

        h3 {
          a {
            font-size: 27px;
            font-weight: 500;
            letter-spacing: 0;
          }
        }
      }
    }

    .isoDashboardMenu {
      padding-top: 0px;
      padding-bottom: 15px;
      background: transparent;

      a {
        text-decoration: none;
        font-weight: 400;
      }

      .ant-menu-item {
        width: 100%;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
        height: 48px;
        padding: 0 15px !important;
      }

      .isoMenuHolder {
        display: flex;
        align-items: center;
      }

      .anticon {
        font-size: 18px;
        margin-right: 30px;
        color: inherit;
        ${transition()};
      }

      i {
        font-size: 19px;
        color: inherit;
        margin: ${(props) =>
          props["data-rtl"] === "rtl" ? "0 0 0 10px" : "0 10px 0 0"};
        width: 18px;
        ${transition()};
      }

      .nav-text {
        font-size: 14px;
        color: inherit;
        font-weight: 400;
        ${transition()};
      }

      .ant-menu-item-selected {
        background-color: rgba(0, 0, 0, 0.4) !important;
        .anticon {
          color: #fff;
        }

        i {
          color: #fff;
        }

        .nav-text {
          color: var(--accent-color, #002a49);
        }
      }

      > li {
        &:hover {
          i,
          .nav-text {
            color: #ffffff;
          }
        }
      }
    }

    .ant-menu-dark .ant-menu-inline.ant-menu-sub {
      background: ${palette("secondary", 5)};
    }

    .ant-menu-submenu-inline,
    .ant-menu-submenu-vertical {
      > .ant-menu-submenu-title {
        width: 100%;
        display: flex;
        align-items: center;
        // padding: 0 !important;

        > span {
          display: flex;
          align-items: center;
        }

        &:after {
          content: "\f123";
          font-family: "Ionicons" !important;
          font-size: 16px;
          color: inherit;
          left: ${(props) => (props["data-rtl"] === "rtl" ? "16px" : "auto")};
          right: ${(props) => (props["data-rtl"] === "rtl" ? "auto" : "16px")};
          ${transition()};
        }

        &:hover {
          &:after {
            color: #ffffff;
          }
        }
      }

      .ant-menu-inline,
      .ant-menu-submenu-vertical {
        > li:not(.ant-menu-item-group) {
          padding-left: ${(props) =>
            props["data-rtl"] === "rtl" ? "0px !important" : "60px !important"};
          padding-right: ${(props) =>
            props["data-rtl"] === "rtl" ? "74px !important" : "0px !important"};
          font-size: 13px;
          font-weight: 400;
          color: inherit;
          ${transition()};

          &:hover {
            color: #ffffff;
          }
        }

        .ant-menu-item-group {
          padding-left: 0;

          .ant-menu-item-group-title {
            padding-left: 100px !important;
          }
          .ant-menu-item-group-list {
            .ant-menu-item {
              padding-left: 125px !important;
            }
          }
        }
      }

      .ant-menu-sub {
        background-color: transparent !important;
      }
    }

    &.ant-layout-sider-collapsed {
      .nav-text {
        display: none;
      }

      .ant-menu-submenu-inline > {
        .ant-menu-submenu-title:after {
          display: none;
        }
      }

      .ant-menu-submenu-vertical {
        > .ant-menu-submenu-title:after {
          display: none;
        }

        .ant-menu-sub {
          background-color: transparent !important;

          .ant-menu-item {
            height: 35px;
          }
        }
      }
    }
  }
`;

export default WithDirection(SidebarWrapper);
